import { Tier } from './entities';
export function getThemeGradient(tier, colorSet) {
    switch (tier) {
        case Tier.free:
            return {
                colors: [
                    colorSet.elements.statusOffline,
                    colorSet.elements.statusOffline,
                ],
            };
        case Tier.plus:
            return colorSet.gradients.plus;
        case Tier.pro:
            return colorSet.gradients.pro;
        case Tier.ultimate:
            return colorSet.gradients.ultimate;
        default:
            return undefined;
    }
}
